import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { FaFileExcel } from 'react-icons/fa';

import { byDateCalendar } from './byDateCalendar';

// Windows rejects these in file names; the semester dates carry slashes.
const toFileName = ({ description, startDay, endDay } = {}) => {
    const name = [description, startDay && endDay && `${startDay}-${endDay}`]
        .filter(Boolean)
        .join(' ')
        .replace(/[\\/:*?"<>|]/g, '.')
        .trim();
    return `${name || 'schedule'}.xlsx`;
};

/**
 * Downloads the calendar currently on screen as an .xlsx file.
 *
 * <p>Takes either a week-based fullSchedule (a short semester) or a by-date payload, the same
 * things the two calendar views receive, plus the view mode, so the file holds what the table
 * shows. The by-date payload is converted only on click, which keeps the conversion out of every
 * render and out of the parent's hook order.
 */
const CalendarXlsxButton = ({ fullSchedule, byDate, viewMode, t }) => {
    const [busy, setBusy] = useState(false);

    const handleClick = async () => {
        setBusy(true);
        try {
            // Loaded on click: exceljs is large and most visitors never export.
            const { exportCalendarScheduleXls } = await import('./exportCalendarScheduleXls');
            const calendar = byDate ? byDateCalendar(byDate) : { fullSchedule };
            const { semester } = calendar.fullSchedule;

            await exportCalendarScheduleXls(
                calendar.fullSchedule,
                { viewMode, cardsFor: calendar.cardsFor, title: semester?.description },
                toFileName(semester),
            );
        } catch (error) {
            console.error('Calendar schedule export failed', error);
        } finally {
            setBusy(false);
        }
    };

    return (
        <Button
            variant="outlined"
            size="small"
            startIcon={<FaFileExcel />}
            onClick={handleClick}
            disabled={busy}
        >
            {t('common:export_xlsx', 'Excel')}
        </Button>
    );
};

export default CalendarXlsxButton;